import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

export const ListImagesThumbnail = () => (
  <Flex direction="column" gap="6px" pt={1} w="full">
    {[0, 1, 2].map((i) => (
      <Flex align="center" gap="6px" key={i}>
        <Box
          bg={ACCENT}
          borderRadius="2px"
          flexShrink={0}
          h="12px"
          opacity={0.6}
          w="12px"
        />
        <Box bg={BAR} borderRadius="2px" flex={1} h="7px" />
      </Flex>
    ))}
  </Flex>
);
